import { render, staticRenderFns } from "./PersonalCompanyData.vue?vue&type=template&id=190042e5&scoped=true"
import script from "./PersonalCompanyData.vue?vue&type=script&lang=js"
export * from "./PersonalCompanyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190042e5",
  null
  
)

export default component.exports